import React__default from 'react';
import { useDeliveryIntervalOptions } from '../../../components/DeliveryIntervalSelect/use-delivery-interval-options.js';
import { DeliveryIntervalSelect } from '../../../components/DeliveryIntervalSelect/DeliveryIntervalSelect.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const CLDeliveryIntervalSelect = ({ className  })=>{
    const { deliveryIntervalOptions: defaultDeliveryIntervals  } = useProductData();
    const { actions , state , triggerToastMessage  } = useCLEcommContext();
    const { deliveryInterval: deliveryInterval1  } = state.configurations.subscriptionPurchaseConfigurations;
    const { deliveryIntervalOptions , selectedInterval  } = useDeliveryIntervalOptions({
        deliveryInterval: deliveryInterval1,
        deliveryIntervalOptions: defaultDeliveryIntervals
    });
    // Get UI validation state for the delivery interval component
    const { deliveryInterval: { showError  } , invalidSubmissionsCount ,  } = state.configurator;
    React__default.useEffect(()=>{
        if (showError) {
            triggerToastMessage('delivery-interval-error');
        }
    }, [
        showError,
        invalidSubmissionsCount
    ]);
    const handleIntervalSelection = React__default.useCallback((deliveryInterval)=>actions.updateDeliveryInterval(deliveryInterval)
    , [
        actions
    ]);
    if (!deliveryIntervalOptions) {
        console.error('DeliveryIntervalSelect: No delivery interval options have been set');
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(DeliveryIntervalSelect, {
        className: className,
        hasError: showError,
        selectedInterval: selectedInterval,
        deliveryIntervalOptions: deliveryIntervalOptions,
        onIntervalSelection: handleIntervalSelection
    });
};

export { CLDeliveryIntervalSelect };
//# sourceMappingURL=CLDeliveryIntervalSelect.js.map
